import React from 'react'


export const AboutItem = (item) => {
    let arr='';
    if(Array.isArray(item.name)){
        item.name.map((a,i)=>{
            arr += (i===0 || i===item.name.length-1? ' ': ', ' ) + (i===item.name.length-1?'ve ':'') + a.title
            return true;
        })
        if(4>=item.name.length) 
           arr = `${item.name.length} knows`
        else 
            arr +=  ' knowws'
    }
    return (
        <li className=""> 
                {!item.avatar && <div className={`iconic ${item.edit ? 'edit': ''}`}>
                    {item.symbol}
                </div>}
                {item.avatar && <div className="iconic">
                    <img src={item.avatar} height="50" width="50" className="rounded" alt="" />
                </div>}

                <div className="detail">
                    <h5 className="title">{Array.isArray(item.name) ? arr : item.name }</h5>
                    {item.description && <p className="description">{item.description}</p>}
                </div>
               
        </li>


    )
}
  

